/**
 * Scrolls to the element with an offset.
 *
 * Uses {@link window.scrollTo}  to scroll to the element with an offset.
 * @param element
 * @param offset
 */
export function scrollToElementWithOffset(element, offset) {
    // would be simpler but does not have an offset
    // element.scrollIntoView({ behavior: "auto", block: "start" });
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY + offset;
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
    });
}
//# sourceMappingURL=scrollToElementWithOffset.js.map